import type { ReactNode } from 'react';
import wordmark from '../assets/fametrue-wordmark.png';
import wordmarkCompact from '../assets/fametrue-wordmark-compact.png';

/**
 * Logotipo Fametrue, estratto dall'Allegato A dove viaggiava come PNG in base64.
 * Le due varianti sono le stesse due presenti nel riferimento: quella grande
 * (600x100) per login e schermata di benvenuto, quella compatta (300x50) per la
 * sidebar.
 *
 * La scritta "fame" è bianca: il logotipo funziona solo su fondo scuro, ed è
 * infatti l'unico contesto in cui il riferimento lo usa.
 */
interface WordmarkProps {
  /** Altezza in pixel, come negli style inline del riferimento. */
  height: number;
  variant?: 'full' | 'compact';
  center?: boolean;
}

export function Wordmark({ height, variant = 'full', center = false }: WordmarkProps): ReactNode {
  return (
    <img
      src={variant === 'compact' ? wordmarkCompact : wordmark}
      alt="Fametrue"
      style={{
        height: `${height}px`,
        width: 'auto',
        display: 'block',
        ...(center ? { margin: '0 auto' } : {}),
      }}
    />
  );
}
